import { Component, OnInit } from '@angular/core';
import { EngineeringService } from 'src/app/services/engineering/engineering.service';
import { Route } from '@angular/compiler/src/core';
import { Router, ActivatedRoute } from '@angular/router';
import { NgForm } from '@angular/forms';

@Component({
  selector: 'app-purchaselines',
  templateUrl: './purchaselines.component.html',
  styleUrls: ['./purchaselines.component.css']
})
export class PurchaselinesComponent implements OnInit {
data:any;
  constructor(private engineeringservies:EngineeringService, private router:Router,
    private route:ActivatedRoute) { }

  ngOnInit() {
    this.getpurchaseLine();
  }
getpurchaseLine(){
  debugger;
  this.engineeringservies.GetPurchaseLineList().subscribe(
    data=>{
      this.data=data;
      console.log(data);
    }
  )

}
purchaseheadersearch(form : NgForm){

}
}
